/**
 * A numeric value as a step field holds it.
 *
 * Step data is `Record<string, string | number | boolean | null>` — the same
 * count arrives as a number from a phase metric and as a string from a text
 * input — so every reader has to normalise. `usePhases` had this rule privately,
 * and the treatment wizard grew a second copy of it line for line.
 *
 * Extracted rather than exported from `usePhases`, which reaches the API client
 * and so cannot be imported by a test.
 */
export function numericStepValue(value: unknown): number | null {
  if (typeof value === "number") return Number.isFinite(value) ? value : null;
  if (typeof value !== "string" || value.trim() === "") return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}
